var storefrontApp = angular.module("storefrontApp");
storefrontApp.service("atgLetteringSubscriptionService", [
    "$http",
    "$rootScope",
    function ($http, $rootScope) {
        var baseUrl = "storefrontapi/customersubscription";

        return {
            changeFormat: function (changeFormat) {
                return $http.post(baseUrl + "/changeformat", changeFormat);
            },
            convertFile: function (designFile, format) {
                var formData = new FormData();
                formData.append("file", designFile, designFile.name);
                formData.append("format", format);
                return $http.post(baseUrl + "/convertfile", formData, {
                    headers: { "Content-Type": undefined },
                });
            },
            convertPurchasedFile: function (convertPurchasedFileRequest) {
                return $http.post(
                    baseUrl + "/convertpurchasedfile",
                    convertPurchasedFileRequest
                );
            },
            deletefile: function (deleteFileRequest) {
                return $http.post(baseUrl + "/deletefile", deleteFileRequest);
            },
            downgradeCustomerSubscription: function (
                downgradeCustomerSubscriptionRequest
            ) {
                return $http.post(
                    baseUrl + "/downgrade",
                    downgradeCustomerSubscriptionRequest
                );
            },
            downloadFiles: function (downloadFileRequest) {
                $rootScope.$emit("ShowNotificationModal", {
                    modalKey: "downloadStarted",
                    redirectOnOkUrl: "/contact",
                });

                return $http({
                    headers: {
                        "Content-Type":
                            "application/x-www-form-urlencoded; charset=UTF-8",
                    },
                    data: $.param(downloadFileRequest),
                    method: "POST",
                    responseType: "blob",
                    url: baseUrl + "/downloadfiles",
                }).then(
                    function (response) {
                        $rootScope.$emit("CloseNotificationModal");
                        var matchArray =
                            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(
                                response.headers("Content-Disposition")
                            );
                        saveAs(
                            new Blob([response.data], {
                                type: response.headers("Content-Type"),
                            }),
                            matchArray && matchArray.length > 1 && matchArray[1]
                        );
                        $rootScope.$emit("ShowNotificationModal", {
                            modalKey: "downloadCompleted",
                        });
                        return true;
                    },
                    function () {
                        $rootScope.$emit("CloseNotificationModal");
                        $rootScope.$emit("ShowNotificationModal", {
                            modalKey: "downloadError",
                            redirectOnOkUrl: "/contact",
                        });
                        return false;
                    }
                );
            },
            getCustomerSubscription: function () {
                return $http.get(baseUrl + "?t=" + new Date().getTime());
            },
            getCustomerSubscriptionSettings: function () {
                return $http.get(
                    baseUrl + "/settings?t=" + new Date().getTime()
                );
            },
            getFreeDesignsUsed: function () {
                return $http.get(
                    baseUrl + "/freedesignsused?t=" + new Date().getTime()
                );
            },
            getSubscriptionPlans: function () {
                return $http.get(baseUrl + "/plans?t=" + new Date().getTime());
            },
            isConvertedFileValidForConversionToPESAsync: function (
                sourceFileId
            ) {
                return $http.get(
                    baseUrl +
                        "/isconvertedfilevalidforconversiontopes?sourceFileId=" +
                        sourceFileId +
                        "&t=" +
                        new Date().getTime()
                );
            },
            isFileValidForConversionToPESAsync: function (designFile) {
                var formData = new FormData();
                formData.append("file", designFile, designFile.name);
                return $http.post(
                    baseUrl + "/isfilevalidforconversiontopes",
                    formData,
                    {
                        headers: { "Content-Type": undefined },
                    }
                );
            },
            placeOrder: function (customerSubscriptionCheckoutRequest) {
                return $http.post(
                    baseUrl + "/placeorder",
                    customerSubscriptionCheckoutRequest
                );
            },
            searchCustomerSubscriptionConvertedFiles: function (
                searchCriteria
            ) {
                return $http.post(
                    baseUrl + "/searchconvertedfiles",
                    searchCriteria
                );
            },
            updateAutoRenewal: function (autoRenew) {
                return $http.post(baseUrl + "/autorenewal", {
                    autoRenew: autoRenew,
                });
            },
            updateSubscriptionPayment: function (creditCardId) {
                return $http.post(baseUrl + "/subscriptionpayment", {
                    creditCardId: creditCardId,
                });
            },
            zipAndEmail: function (zipAndEmailRequest) {
                return $http.post(baseUrl + "/zipandemail", zipAndEmailRequest);
            },
        };
    },
]);
